<template>
  <div>
    <v-card class='mx-2' outlined>
      <v-card-title>
        {{systemSerNum}}
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search (case sensitive)"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table 
        v-model="selected" 
        :headers="headers" 
        :items="details" 
        :search="search" 
        :custom-filter="filterCaseSensitive"
        sort-by="createdDate"
        no-data-text="No Documents">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="mb-2" @click="newComponent">New Component</v-btn>
            <v-dialog v-model="dialog" max-width="60%" :key="dialogKey">
              <v-card>
                <v-card-title>
                  <span class="headline">Edit Component</span>
                </v-card-title>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-select v-model="compType" label="Type" :items="types"
                      v-validate.initial="'required'" data-vv-name="compType"
                      :error-messages="errors.collect('compType')">
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="compManufacturer" label="Manufacturer" placeholder="Manufacturer, e.g. Intel"
                      v-validate.initial="'required'" data-vv-name="compManufacturer"
                      :error-messages="errors.collect('compManufacturer')">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="compModel" label="Model" placeholder="Model"
                      v-validate.initial="'required'" data-vv-name="compModel"
                      :error-messages="errors.collect('compModel')">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="compRev" label="Rev" placeholder="Rev"
                      v-validate.initial="'required'" data-vv-name="compRev"
                      :error-messages="errors.collect('compRev')">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="compSerNum" label="Serial Number" placeholder="Serial Number"
                      v-validate.initial="'required'" data-vv-name="compSerNum"
                      :error-messages="errors.collect('compSerNum')">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="compCapacity" label="Capacity" placeholder="Capacity"
                      v-validate.initial="'required|numeric'" data-vv-name="compCapacity"
                      :error-messages="errors.collect('compCapacity')">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-select v-model="compState" label="State" :items="states"
                      v-validate.initial="'required'" data-vv-name="compState"
                      :error-messages="errors.collect('compState')">
                      </v-select>
                    </v-col>
                  </v-row>
                </v-container>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn :disabled="errors.any()" color="primary darken-1" @click="save">Save</v-btn>
                  <v-btn color="primary darken-1" @click="close">Cancel</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon class='mr-2' @click="edit(item)"> edit  </v-icon>
          <v-icon class='mr-2' @click="deleteItem(item)"> delete  </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>

/*  Example API return element
    "0": {
      "id": "d0b117b1-bae3-11ea-9784-06853f280874",
      "type": "NIC",
      "manufacturer": "wireguard",
      "model": "10.237.0.79",
      "rev": null,
      "serNum": "9a13f080-34d1-420a-9676-a30943beed10",
      "capacity": null,
      "state": "",
      "createdBy": "drittman",
      "createdDate": "2020-06-30 15:10:20",
      "modifiedBy": "",
      "modifiedDate": "2020-06-30 15:10:20"
    },   */

export default {
  name: "SysDetails",
  props: {
    app: Object,
    systemSerNum: String,
  },
  data: () => ({
    search: '',
    headers: [
/*       {
        text: 'Comp Id',
        align: 'center',
        value: 'id'
      },
 */      {
        text: 'Type',
        align: 'left',
        value: 'type'
      },
      {
        text: 'Manufacturer',
        align: 'left',
        value: 'manufacturer'
      },
      {
        text: 'Model',
        align: 'left',
        value: 'model'
      },
      {
        text: 'Rev',
        align: 'left',
        value: 'rev'
      },
      {
        text: 'Serial Num',
        align: 'left',
        value: 'serNum'
      },
      {
        text: 'Capacity',
        align: 'left',
        value: 'capacity'
      },
      {
        text: 'State',
        align: 'left',
        value: 'state'
      },
      {
        text: 'Date Created',
        align: 'left',
        value: 'createdDate'
      },
      {
        text: 'Date Modified',
        align: 'left',
        value: 'modifiedDate'
      },
      {
        text: 'Actions',
        align: 'center',
        value: 'action',
        sortable: false
      }
    ],
    system: [],
    details: [],
    selected: [],
    compId: '',
    compType: '',
    compManufacturer: '',
    compModel: '',
    compRev: '',
    compSerNum: '',
    compCapacity: 0,
    compState: '',
    dialog: false,
    dialogKey: 0,
    types: ['MB', 'PROC', 'RAM', 'HDD', 'SSD', 'PS', 'OS', 'NIC', 'RAID', 'SW', "LIC"],
    states: ['INVENTORY', 'INSTALLED', 'REMOVED', 'REPLACED', 'RETURNED'],
  }),

  created() {
    console.log('system details created. systemSerNum = ' + this.systemSerNum)
    this.initialize();
  },

  mounted() {
    console.log('systems mounted')
    this.initialize();
  },

  methods: {
    initialize() {
      this.getSystemDetails();
    },

    filterCaseSensitive (value, search, item) {
      let dummy = item ? 1 : 2; // suppress unused variable error
      return value != null && dummy > 0 &&
        search != null &&
        typeof value === 'string' &&
        value.toString().indexOf(search) !== -1
    },
    
    edit(item){
      console.log('editComponent' + JSON.stringify(item));
      console.log(item);
      this.compId = item.id
      this.compType = item.type
      this.compManufacturer = item.manufacturer
      this.compModel = item.model
      this.compRev = item.rev
      this.compSerNum = item.serNum
      this.compCapacity = item.capacity
      this.compState = item.state
      this.dialog = true;
    },

    deleteItem(item) {
      console.log('deleteComponent' + JSON.stringify(item));
      if (confirm("Are you sure you want to delete " + item.manufacturer + " : " + item.model +"?")) {
        this.deleteComponent(item.id)
      }
    },

    newComponent() {
      this.compId = ''
      this.compType = ''
      this.compManufacturer = ''
      this.compModel = ''
      this.compRev = ''
      this.compSerNum = ''
      this.compCapacity = 0
      this.compState = ''
      this.dialog = true
    },

    save() {
      console.log("save " + this.compId);
      this.crudComponent(this.compId)
      this.dialog = false
    },

    close() {
      this.dialog = false
    },

    getSystemDetails() {
      // https://portal.qumulex.dev/API/public/system/QF2720ED004F
      console.log('/API/public/system')
      let url = '/API/public/system/'
      url += this.systemSerNum
      this.app.restApi({
          method: 'get',
          url: url,
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          }
        })
        .then(response => {
          this.system = Object(response.data);
          console.log("getSystemDetails " + this.system.id + this.system.model)
          this.details = Object.values(response.data.components);
        })
        .catch(error => {
          console.log(error);
        });
    },

    crudComponent(id) {
      let url = '/API/public/component/' + (id === '' ? 'new' : id)
      url += "?manufacturer=" + this.compManufacturer
      url += "&model=" + this.compModel
      url += "&rev=" + this.compRev
      url += "&serNum=" + this.compSerNum
      url += "&type=" + this.compType
      url += "&state=" + this.compState
      url += "&capacity=" + this.compCapacity
      url += "&systemId=" + this.system.id
      console.log('updateComponent(): url=' + url)
      this.app.restApi({
          method: 'post',
          url: url,
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          }
        })
        .then(response => {
          console.log(response);
          this.getSystemDetails() // refresh table
        })
        .catch(error => {
          console.log(error);
          alert("Update Component failed (" + error.response.status + ")")
        });
    },

    deleteComponent(id) {
      console.log('deleteComponent')
      this.app.restApi({
          method: 'delete',
          url: '/API/public/component/' + id,
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          }
        })
        .then(response => {
          console.log(response);
          this.getSystemDetails() // refresh table
        })
        .catch(function (error) {
          console.log(error);
          alert("Delete Component failed (" + error.response.status + ")")
        });
    },

  }
}
</script>